import { invokeRPC } from './socket.js'

export function getUsersForProject(projectId, customerId) {
  return invokeRPC('userResources', 'getUsersForProject', {
    project_id: projectId,
    customer_id: customerId
  })
}

export function getUsersWithProjectAccess(projectId, customerId) {
  return invokeRPC('userResources', 'getUsersWithProjectAccess', {
    project_id: projectId,
    customer_id: customerId
  })
}

export function getUserViewAccessForViewGrid(userId, projectId) {
  return invokeRPC('userResources', 'getUserViewAccessForViewGrid', {
    user_id: userId,
    project_id: projectId
  })
}

export function setProjectAccess(projectId, customerId, addUsers, removeUsers) {
  return invokeRPC('userResources', 'setProjectAccess', {
    project_id: projectId,
    customer_id: customerId,
    addUsers: addUsers,
    removeUsers: removeUsers
  })
}

export function setViewAccess(userViewMatrix) {
  return invokeRPC('userResources', 'setViewAccess', {
    user_to_view_matrix: userViewMatrix
  })
}

export function getViewAccess(viewIds) {
  return invokeRPC('userResources', 'getViewAccess', {
    view_ids: viewIds
  })
}

export function setUserProjectAccess(userId, customerId, addProjects, removeProjects) {
  return invokeRPC('userResources', 'setUserProjectAccess', {
    user_id: userId,
    customer_id: customerId,
    addProjects: addProjects,
    removeProjects: removeProjects
  })
}

export function getAllProjectsForUser(userId) {
  return invokeRPC('userResources', 'getAllProjectsForUser', {
    user_id: userId
  })
}

export function getAllAbilities() {
  return invokeRPC('userResources', 'getAllAbilities')
}

export function setUserAbilities(userId, add, remove) {
  return invokeRPC('userResources', 'setUserAbilities', {
    user_id: userId,
    addAbilities: add,
    removeAbilities: remove
  })
}